module.exports = __webpack_public_path__ + "media/icons/upload-d9d0d941.svg";